export default __webpack_public_path__ + "static/media/illustration-health-1-m@2x.41157f2e.webp";